module.exports = __webpack_public_path__ + "img/empty.4d3decb8.png";